import type { ComponentProps } from "react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      closeButton
      position="top-right"
      expand
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-black group-[.toaster]:border-gray-200 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-600",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-gray-100",
          cancelButton:
            "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-600",
          closeButton: "rounded-xl",
          success:
            "group-[.toaster]:border-mint-500 **:data-icon:text-mint-500",
          error: "group-[.toaster]:border-red **:data-icon:text-red",
          warning: "group-[.toaster]:border-orange **:data-icon:text-orange",
          info: "group-[.toaster]:border-primary **:data-icon:text-primary",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
